/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  padding: 60px 40px;
  height: 100vh;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */

  color: #fff;

  h1 {
    margin-bottom: 30px;
    font-size: 24px;
  }

  p {
    margin-left: 20px;
    margin-bottom: 5px;
    font-size: 20px;
  }

  div.link {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 220px;
    height: 50px;
    border: 1px solid #333;
    border-radius: 5px;
    padding: 10px;
    font-weight: bold;
    background: #36ded6;

    margin: 30px;

    a {
      color: #333;
      font-size: 18px;
    }
  }

  div.feedback {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    width: 90%;
    height: 200px;
    border: 1px solid #36ded6;
    border-radius: 5px;
    padding: 20px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0);
    font-size: 18px;

    margin: 30px;
  }

  div.job {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    width: 220px;
    height: 50px;
    border: 1px solid #fff;
    padding: 10px;
    /* font-weight: bold; */
    border-radius: 5px;

    margin: 30px;
  }
`;
